import { deleteSalesType } from "../../../../../actions/Utilities/SalesType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteSalesType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteSalesType(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetSalesType"]);
      toast.fire(
        "Success",
        "Sales Type has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Sales Type",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteSalesType;
